import React from 'react';
import './QualityScore.css';

function QualityScore({ score, versaoAnalise }) {
  if (score === null || score === undefined) return null;

  const getScoreClass = () => {
    if (score >= 80) return 'score-high';
    if (score >= 60) return 'score-medium';
    return 'score-low';
  };

  const getScoreLabel = () => {
    if (score >= 80) return 'Completa';
    if (score >= 60) return 'Boa';
    if (score >= 40) return 'Parcial';
    return 'Incompleta';
  };

  // SVG donut: circunferência = 2 * π * r = 2 * π * 54 ≈ 339.3
  const r = 54;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;

  return (
    <div className={`quality-score ${getScoreClass()}`}>
      <div className="score-header">
        <h4>Completude da análise</h4>
      </div>

      <div className="score-svg-wrap">
        <svg width="140" height="140" viewBox="0 0 140 140">
          <circle
            className="score-svg-bg"
            cx="70" cy="70" r={r}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="12"
          />
          <circle
            className="score-svg-fill"
            cx="70" cy="70" r={r}
            fill="transparent"
            stroke="currentColor"
            strokeWidth="12"
            strokeDasharray={circ}
            strokeDashoffset={offset}
            strokeLinecap="round"
          />
        </svg>
        <div className="score-center-text">
          <span className="score-number">{score}</span>
          <span className="score-max">/ 100</span>
        </div>
      </div>

      <span className="score-label-pill">{getScoreLabel()}</span>
      <p className="score-clarifier">Mede o quão completa e estruturada está a análise; não garante a correção da causa raiz.</p>
    </div>
  );
}

export default QualityScore;
